<template>
  <div class="text-center painel">
    <h1 class="mb-0">Solicitação enviada!</h1>
    <p>
      Caso o login seja válido, você receberá um e-mail com link para criar sua
      senha.<br />
      Não esqueça de verificar sua caixa de spam.
    </p>
    <img
      class="successful_link_image"
      :src="imageSrc"
      alt="Solicitação enviada com sucesso"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["isSerasa"]),
    imageSrc() {
      return this.isSerasa
        ? require("../../public/img/successful_link.svg")
        : require("../../public/img/successful_link_clear.svg");
    },
  },
};
</script>

<style scoped>
.successful_link_image {
  background-repeat: no-repeat;
}
@media screen and (max-width: 1490px) {
  .successful_link_image {
    background-repeat: no-repeat;
    width: 55%;
    height: 55%;
  }
}
</style>
